import React from 'react';

import { formatDateWithHour } from 'src/utils/Date';
import Loading from 'src/components/Loading';
import styles from './JobStatus.scss';
import { useTranslation } from 'react-i18next';

const JobInprogress = ({ statusText, jobInfo, startAt }) => {
  const { t } = useTranslation();
  return (
    <li>
      <div className={styles.waiting}>
        <div className={styles.loading}>
          <Loading />
        </div>
        <div className={styles.info}>
          <p className={styles.title}>
            {jobInfo}
            <br />
            {statusText}
          </p>
          <div className={styles.dates}>
            <dl>
              <dt>{t('components.JobStatus.AllJobStatus.executed_date')}：</dt>
              <dd>{formatDateWithHour(startAt)}</dd>
            </dl>
          </div>
        </div>
      </div>
    </li>
  );
};

export default JobInprogress;
